import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-primary, #FFF9F2)' }}>
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '48px 24px' }}>
        <button
          onClick={() => navigate('/')}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            background: 'none', border: 'none', cursor: 'pointer',
            color: 'var(--text-secondary, #555)', fontSize: 14, marginBottom: 32
          }}
          data-testid="terms-back-btn"
        >
          <ArrowLeft size={16} /> Terug naar Home
        </button>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
          <FileText size={28} style={{ color: 'var(--accent-primary, #6366f1)' }} />
          <h1 style={{ fontSize: 32, fontWeight: 600, color: 'var(--text-primary, #232323)', margin: 0 }}>
            Algemene Voorwaarden
          </h1>
        </div>

        <p style={{ color: 'var(--text-secondary, #555)', marginBottom: 8, fontSize: 14 }}>
          Laatst bijgewerkt: februari 2026
        </p>

        <div style={{ background: '#0E1620', borderRadius: 16, padding: '40px 36px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', lineHeight: 1.7, color: '#F4F7FB', fontSize: 15 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB', marginTop: 0 }}>1. Algemeen</h2>
          <p>Deze Algemene Voorwaarden zijn van toepassing op alle diensten die worden aangeboden door Krypton9. Door gebruik te maken van onze diensten, gaat u akkoord met deze voorwaarden.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>2. Diensten</h2>
          <p>Krypton9 biedt AI-consultancy, implementatiediensten en een online platform voor MKB-bedrijven. Wij behouden ons het recht voor om diensten te wijzigen of te beëindigen met redelijke voorafgaande kennisgeving.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>3. Gebruikersaccount</h2>
          <p>Bij het aanmaken van een account bent u verantwoordelijk voor:</p>
          <ul>
            <li>Het verstrekken van accurate en actuele informatie</li>
            <li>Het vertrouwelijk houden van uw inloggegevens</li>
            <li>Alle activiteiten die plaatsvinden onder uw account</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>4. Intellectueel eigendom</h2>
          <p>Alle content, software en materialen op het Krypton9-platform zijn eigendom van Krypton9 of haar licentiegevers en worden beschermd door auteursrecht en andere intellectuele-eigendomsrechten.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>5. Aansprakelijkheid</h2>
          <p>Krypton9 is niet aansprakelijk voor indirecte schade, gevolgschade of gederfde winst. Onze aansprakelijkheid is beperkt tot het bedrag dat u heeft betaald voor de betreffende dienst in de 12 maanden voorafgaand aan de claim.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>6. Toepasselijk recht</h2>
          <p>Op deze voorwaarden is Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in Nederland.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>7. Contact</h2>
          <p>Voor vragen over deze voorwaarden kunt u contact opnemen via:</p>
          <p style={{ fontWeight: 500 }}>E-mail: info@krypton9.com</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
